import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.hr`
  position: absolute;
  bottom: -2px;
  right: 63px;
  width: calc(100% - 47px);
  height: 1px;
  display: block;
  margin: 0;
  border: none;
  background-color: #504f51;

  @media screen and (min-width: ${DESKTOP}px) {
    bottom: -12px;
  }
`;
